{
  "allItems": "All Runs",
  "chunkState": {
    "empty": "no annotations",
    "failed": "failed",
    "proposed": "proposed",
    "proposing": "being proposed"
  },
  "chunk_one": "Change set {{number}} ({{count}} Run)",
  "chunk_other": "Change set {{number}} ({{count}} Runs)",
  "chunks": "Change sets for review",
  "column": {
    "attempt": "Attempt",
    "state": "State",
    "unit": "Document or segment",
    "usage": "Used"
  },
  "complete": "Complete",
  "concurrencyInForce_one": "{{count}} at once",
  "concurrencyInForce_other": "{{count}} at once",
  "connectorOffline": "DMW Connector offline",
  "connectorOnline": "DMW Connector online",
  "control": {"cancel": "Cancel the batch", "pause": "Pause", "resume": "Resume", "start": "Start"},
  "corpusVersion": "Corpus version",
  "costSoFar": "Used so far",
  "dependsOn": "Depends on",
  "eta": "Time left",
  "filter": "Show Runs",
  "held": "waiting: the provider asked to slow down, or the LLM route's budget is spent",
  "heldUntil": "until {{time}}",
  "humanSteps": {"queue": "Wait for a person in each Run", "skip": "Skip them: review at the end"},
  "itemState": {
    "cancelled": "Cancelled",
    "done": "Done",
    "failed": "Failed",
    "pending": "Pending",
    "running": "Running",
    "waiting_for_human": "Waiting for a person"
  },
  "items": "Runs",
  "list": {
    "progress_one": "{{done}} done, {{failed}} failed, of {{count}}",
    "progress_other": "{{done}} done, {{failed}} failed, of {{count}}",
    "title": "Batches"
  },
  "missingUnits": "Missing units",
  "nextPage": "Next",
  "ofTotal_one": "of {{count}} Run",
  "ofTotal_other": "of {{count}} Runs",
  "openThread": "Run",
  "partial": "Partial",
  "pauseReason": {
    "connector_offline": "the DMW Connector is offline",
    "item_withdrawn": "an item the process schema uses was withdrawn; no further Run can start",
    "repeated_failures": "several Runs in a row failed; look before more start",
    "requested": "paused by you",
    "route_blocked": "the LLM route's key or credit was refused"
  },
  "planUnits": "Plan units",
  "previousPage": "Previous",
  "retry": "Retry",
  "review": "Review",
  "setConcurrency": "Set",
  "start": {
    "batchTitle": "Title",
    "changeSets": "Proposals",
    "chosenDocuments": "Chosen documents (by key)",
    "chunkSize": "Runs per change set",
    "chunked": "Change sets of N Runs",
    "concurrency": "At once",
    "concurrencyDefault": "as the DMW Connector allows",
    "connectorHint": "Every LLM call runs on your DMW Connector. If it goes offline, the batch pauses and resumes when it is back; finished calls are never repeated.",
    "documents": "Which documents",
    "field": "Field",
    "humanSteps": "Steps that need a person",
    "keysPlaceholder": "One document key per line",
    "many": "many documents",
    "metadata": "Documents with a metadata value",
    "open": "Apply to many documents",
    "perItem": "One change set per Run",
    "preview": "Show what it runs on",
    "problem": {
      "noDocuments": "Name at least one document key.",
      "noMetadata": "Name a metadata field and its value.",
      "segmentType": "A segment type is lowercase letters, digits and underscores."
    },
    "route": "LLM route",
    "routeHint": "An API key has its own metered quota; a subscription agent shares your personal limits. Both run on your DMW Connector.",
    "segmentType": "Only segments of this type (optional)",
    "segmentTypePlaceholder": "for example scene",
    "starting": "Starting…",
    "submit": "Start the batch",
    "subtitle": "One Run per document or segment, with this Run's process schema, LLM route and profile, on your DMW Connector.",
    "title": "Apply this process schema to many documents",
    "units_one": "{{count}} Run",
    "units_other": "{{count}} Runs",
    "value": "Value",
    "wholeCorpus": "The whole corpus version"
  },
  "state": {
    "cancelled": "Cancelled",
    "completed": "Completed",
    "failed": "Finished with failures",
    "paused": "Paused",
    "planned": "Planned",
    "running": "Running"
  },
  "statementParts": "Part results",
  "unknown": "not known yet",
  "unplannable": "Unplannable",
  "vitaAssemblies": "Vita assemblies",
  "vitaNotFound": "This vita assembly is not available.",
  "workflow": "Process schema"
}
